<template>
    <el-dialog center custom-class="online-dialog-class"  title="提卡成功" :visible.sync="dialogVisible"  :before-close="closeOnlineDetail" @close = "closeOnlineDetail" width="600px" :close-on-click-modal="false">                
        <el-descriptions class="margin-top" title="带边框列表" :column="2"  border>           
            <el-descriptions-item label-class-name="my-label" content-class-name="my-content">
                <template slot="label">卡类</template>
                {{dialogObj.product_name}}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="my-label" content-class-name="my-content">
                <template slot="label">面值</template>
                {{dialogObj.face_value}}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="my-label" content-class-name="my-content">
                <template slot="label">数量</template>
                    {{dialogObj.quantity}}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="my-label" content-class-name="my-content">
                <template slot="label">总金额</template>
                    {{dialogObj.total_amount}}
            </el-descriptions-item>
        </el-descriptions>
        <div class="mt20">
            <div class="password-title">卡密信息：</div>
            <div class="password-list" v-if="dialogObj && dialogObj.cards">
                <div class="password-item" v-for="(item,index) in dialogObj.cards" :key="index">
                    <div class="password-number">{{index + 1}}.</div>
                    <div class="password-details">
                        <div class="card-info">
                            <span class="info-label">卡号：</span>
                            <span class="info-value">{{item.card_number}}</span>
                        </div>
                        <div class="card-info">
                            <span class="info-label">卡密：</span>                
                            <span class="info-value">{{item.card_password}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="copyAll" type="primary" icon="el-icon-copy-document" >一键复制所有卡密</el-button>
            <el-button size="small" @click="closeOnlineDetail">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'onlineCardDetail',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false,
        },
        dialogObj:{
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            editBalanceHeight: '',
            size: 'mini',
        }
    },
    mounted() {
    },
    methods:{
        copyAll(){
            let textCopy = ''
            for (let i = 0; i < this.dialogObj.cards.length; i++) {
                textCopy += (i+1)+'. 卡号：' + this.dialogObj.cards[i].card_number + ' 卡密：' + this.dialogObj.cards[i].card_password + '\n'
            }
            const textarea = document.createElement('textarea')
            textarea.value = textCopy
            document.body.appendChild(textarea)
            textarea.select() // 选择对象
            document.execCommand('Copy') // 执行浏览器复制命令
            document.body.removeChild(textarea) // 删除DOM
            this.$message({
                type: 'success',
                message: '已复制到剪切板'
            })
        },
        closeOnlineDetail(){
            this.$emit('closeOnlineDetail')
        },
    }
}
</script>
<style lang="scss">
    .online-dialog-class{
        .my-label{
            background: #f5f7fa;
            color: #606266;
            font-weight: 700 !important;
        }
        .my-content{
            color:#303133;
        }
    }
</style>
<style lang="scss" scoped>
.online-dialog-class{
    .password-title{
        color: #303133;
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 12px;
    }
    .password-list {
        max-height: 300px;
        overflow-y: auto;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 12px;
        background-color: #f5f7fa;
        .password-item {
            display: flex;
            padding: 12px 0;
            border-bottom: 1px solid #E4E7ED;
            font-family: Courier New, monospace;
            &:last-child {
                border-bottom: none;
            }
            .password-number {
                color: #909399;
                font-size: 14px;
                width: 30px;
                flex-shrink: 0;
                font-weight: 600;
            }
            .password-details {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 4px;
                .card-info {
                    display: flex;
                    align-items: center;
                    .info-label {
                        color: #606266;
                        font-size: 14px;
                        font-weight: 500;
                        width: 50px;
                        flex-shrink: 0;
                    }
                    .info-value {
                        color: #303133;
                        font-size: 14px;
                        font-weight: 600;
                        letter-spacing: 1px;
                        word-break: break-all;
                        font-family: Courier New, monospace;
                    }
                }
            }
        }
    }
}
</style>